import gsap from "gsap";

const intiAni = gsap.timeline({paused:true})
        .addLabel('start')
        .from(".apsaranta__bg", 7, {scale:1.5, ease:"Power1.easeOut"},"start")
        .from(".apsaranta__title", 0.9, {y:120, autoAlpha:0, ease:"Power1.easeOut"}, "start+=0.5")
        .from(".apsaranta__txt", 0.9, {y:120, autoAlpha:0, ease:"Power1.easeOut"}, "start+=0.7")
        .from(".apsaranta__txt2", 0.9, {y:120, autoAlpha:0, ease:"Power1.easeOut"}, "start+=1.3")
        .from(".apsaranta__btn", 0.9, {y:120, autoAlpha:0, ease:"Power1.easeOut"}, "start+=1.5");


export default {
    id: '#apsaranta',
    name: '아프사란타',
    enterStart() {
        intiAni.seek(0);
        intiAni.play();
    },
    enterEnd(){

    },
    leaveStart() {

    },
    leaveEnd(){
        $("#event").removeClass("v-sec--on");
    }
};



// WEBPACK FOOTER //
// ./src/js/page/apsaranta.js